import * as Yup from 'yup';

import { createFormConfig, ValidationRules } from 'helpers/createFormConfig';

export enum AddPersonneMoralePlateformeFieldNames {
  PlateformeId = 'plateformeId',
}

export interface AddPersonneMoralePlateformeFormValues {
  [AddPersonneMoralePlateformeFieldNames.PlateformeId]: string;
}

const validationRules: ValidationRules<keyof AddPersonneMoralePlateformeFormValues> = {
  [AddPersonneMoralePlateformeFieldNames.PlateformeId]: Yup.string().required(
    "La plateforme est requise",
  ),
};

export const addPersonneMoralePlateformeFormConfig =
  createFormConfig<AddPersonneMoralePlateformeFormValues>(validationRules, {
    [AddPersonneMoralePlateformeFieldNames.PlateformeId]: '',
  });
